import { usePatchLayerMutation } from "./mutations";
import { useApplyLayerFieldToCache } from "./mutations/usePatchLayerMutation";

// Immediate local update (so the UI doesn't wait on the round-trip),
// backed by a TanStack mutation for the actual network write.
export default function usePatchLayer() {
    const applyLayerFieldToCache = useApplyLayerFieldToCache();
    const patchLayerMutation = usePatchLayerMutation();
    return (layer: any, field: string, value: any, callApi = true) => {
        if (!callApi) {
            applyLayerFieldToCache(layer, field, value);
            return Promise.resolve();
        }
        return patchLayerMutation.mutateAsync({ layer, field, value });
    };
}
